<template>
  <div class="help-doc">
    <router-view @refresh="refresh"></router-view>
    <contentView  v-if="isDetail==false">
      <template slot="operateLeft">
        <el-input class="enter-input" v-model="searchVal"  size="small" placeholder="请输入内容" @keyup.enter.native="search"></el-input>
        <el-button style="margin-left: 15px;" size="small" @click="onOpt('','add')">新建分类</el-button>
        <el-button style="margin-left: 15px;" size="small" @click="addDoc">新建文档</el-button>
        
      </template>
      <template slot="operateRight"></template>
      <div slot="operateLine">
        <div class="top-tab">
          <!-- <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="用户管理" name="first">
                
              </el-tab-pane>
              <el-tab-pane label="配置管理" name="second"></el-tab-pane>
          </el-tabs> -->
        </div>
        
      </div>
      <template slot="contentLeft">
        <div class="left-card">
                <!-- <div class="left-header">
                    <div class="left-header-title">分类</div>
                    <div>
                      <i class="el-icon-circle-plus header-opt-icon" @click="onOpt('','add')"></i>
                    </div>
                </div> -->
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="尚匠云后台" name="0">   
                    </el-tab-pane>
                    <el-tab-pane label="尚匠云小程序" name="1"></el-tab-pane>
                </el-tabs> 
                <el-tree
                :data="typeList"
                :highlight-current="true"
                node-key="id"
                :default-checked-keys="checkedId"
                ref="menuTree"
                class="type-list-tree"
                default-expand-all
                @node-click="onSelect"
                :expand-on-click-node="false">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ data.menuName }}</span>
                  <span v-if="data.menuName!='全部'">
                    <i class="el-icon-edit role-opt-icon"   @click.stop="onOpt(data,'edit')"></i>
                    <i style="margin-left:10px" class="el-icon-delete role-opt-icon" @click.stop="deleteClass(data,'delete')"></i>
                  </span>
                </span>
              </el-tree>
        </div>
      </template>
      
      <el-table slot="contentBox" height="100%" border :data="tableData"  @row-click="onDetail" style="width: 100%">
        <el-table-column prop="title"  label="标题"></el-table-column>
        <!-- <el-table-column prop="content" label="内容" ></el-table-column> -->
        <el-table-column prop="createdTime" label="发布时间" width="180"></el-table-column>
        <el-table-column prop="pushUser" label="操作" width="140">
          <template slot-scope="scope">
            <el-button @click.stop="onRemove(scope.row)" type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </contentView>
    <el-dialog title="公告详情" width="420px" :visible.sync="dialogFormVisible">
        <el-form :model="form"  label-position="top">
            <el-form-item label="分类名称" prop="MenuName">
                <el-input  v-model="form.MenuName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="上级分类" >
                <!-- <el-input v-model="form." autocomplete="off"></el-input> -->
            <el-cascader
              ref="typeCascader"
              v-model="form.ParentId"
              :options="typeList"
              :props="{ checkStrictly: true ,emitPath:false,label:'menuName',value:'menuID' }"
              clearable style="margin-bottom:15px;width:100%;"></el-cascader>
            </el-form-item>
            <el-form-item label="类型" >
                <el-select v-model="form.Mtype" placeholder="请选择"  style="margin-bottom:15px;width:100%;">
                  <el-option
                    v-for="item in docType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序" >
                <el-input v-model="form.Morderby" prop="Morderby" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button style="color:#fff" type="primary" @click="onSave">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import contentView from "@/components/ContentView";
import apiPub from '@/api/public'
export default {
  name: "enterprise",
  data() {
    return {
      tableData: [],
      searchVal:"",
      typeList:[],
      checkedId:[],
      typeIndex:0,
       options:[],
       activeName:"0",
       docType:[
         {label:"尚匠云后台",value:"0"},
         {label:"尚匠云小程序",value:"1"}
        ],
       dialogFormVisible:false,
       form:{
           MenuName:"",
           ParentId:"0",
           Mtype:"",
           Morderby:"",
           Auth_State:"0"
       },
       rules:[{
        MenuName: [
            { required: true, message: '请输入分类名称', trigger: 'blur' },
            
          ],
          Morderby: [
            { required: true, message: '排序不能为空', trigger: 'blur' }
          ],
       }],
    menuID:"",
      win: false,
      value: "",
      timesRun: 0,
      isDetail:false
    };
  },
  components: {
    contentView:contentView
  },
  watch:{
      $route(to,from){
        // console.log(to);
        // this.controlRouter()
        if (to.name != 'helpDoc') {
          this.isDetail = true;
          
        } else {
          this.isDetail = false;
          this.getTypeList()
          
        }
    }
  },
   computed: {
   ...mapGetters(["currentUser"]),
  },
  created() {
      //  console.log(this.currentUser)  
    // this.search();
    this.getTypeList();
    this.controlRouter()
  },
  methods: {
    refresh(val){
      // console.log(val)
      this.menuID=val.id;
    },
    //---------------查询区域--------begin-----------
    controlRouter() {
      // console.log(this.$router.currentRoute)
       if (this.$router.currentRoute.name != 'helpDoc') {
        this.isDetail = true;
      } else {
        this.isDetail = false;
      }
    },
    search(){
      this.getlist()
    },
    addDoc(){
      this.$router.push({
        path: "/helpDoc/docDetail",
        query: { }
      });
    },
    
    //---------------业务区域--------end-----------
    onSave(){
      var that=this;
      var data=this.form;
      var userinfo=JSON.parse(localStorage.getItem("userinfo"))
      data.UserID=userinfo.id;
      if(data.MenuName==''){
        that.$message({
            message: '分类名称不能为空',
            type: 'warning'
        });
        return;
      }
      if(data.Morderby==''){
        that.$message({
            message: '排序字段不能为空',
            type: 'warning'
        });
        return;
      }
      var obj = {
        "url": apiPub.AddHelpMenu,
        "data":data
      };
      if(this.form.ID){
          obj.url=apiPub.UpdateHelpMenu
      }
      $http.request(obj,false,function(res) {
        // console.log(res)
        that.$message({
            message: '添加成功',
            type: 'success'
        });
         that.dialogFormVisible=false;
         that.getTypeList(true)
      })
    },
    handleClick(e,val){
      // Mtype
      this.getTypeList()
      // console.log(e)
      // console.log(val)
    },
    onOpt(data,type){
        // console.log(data)
        if(data){
            this.form={
                ID:data.id,
                MenuName:data.menuName,
                ParentId:data.parentID,
                Morderby:data.morderby,
                Auth_State:data.auth_State
            }
        }else{
          this.form={
              MenuName:"",
              ParentId:"0",
              Morderby:"",
              Auth_State:"0"
          }
        }
        // this.$refs.tree.getCurrentKey()
        // console.log(this.$refs.tree.getCheckedKeys());
        this.dialogFormVisible=true;
    },
    onSelect(data,node){
        // console.log(data)
        // console.log(node)
        this.menuID=data.id;
        this.getlist(data.id)
        // console.log(this.$refs.menuTree.getCurrentNode())
    },
    
    //---------------表格操作--------begin-----------
    getTypeList(sty){
    var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.HelpAllMenu,
        "data":{
          Mtype:this.activeName,
        }
        
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
       if(res.data!=''){
         that.typeList=res.data;
        if(!sty){
          // console.log(res.data[0])
          
          // that.$refs.menuTree.setChecked(res.data[0].id);
          // setCurrentKey(10);
          
          if(that.menuID){
            var menuID=that.menuID
             
          }else{
            var menuID=res.data[0].id
          }
         
          setTimeout(function(){
             that.getlist(menuID)
             if(that.$refs.menuTree){
               that.$refs.menuTree.setCurrentKey(menuID);
             }
          },200)
          // is-checked
          // that.checkedId=[res.data[0].id]
        }
       }else{
         that.typeList=[];
       }
        
      })
    },
    getlist(id){
      var that=this;
      var SearchText=this.searchVal||""
      var obj = {
        "url": apiPub.GetHelpInfoList,
        "data":{
          ID:id,
          SearchText:SearchText
        }
      };
      $http.request(obj,false,function(res) {
        // console.log(res)
        if(res.data){
            that.tableData=res.data;
        }else{
            that.tableData=[];
        }
        
      })
    },
    onRemove(data){
      this.$confirm('确认删除该文档?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.doUpdate(data)
            }).catch(() => {
                      
      });
    },
    deleteClass(data){
      var that=this;
      var obj = {
        "url": '/api/Service/DeleteHelpMenu',
        "data":{
          ID:data.id,
          UserID:this.currentUser.id
        }
      };
      this.$confirm('确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          $http.request(obj,false,function(res) {
            that.$message({
              message: '删除成功',
              type: 'success'
            });
            that.getTypeList()
          })
        }).catch(() => {          
      });
    },
    doUpdate(data){
      var that=this;
      var obj = {
        "url": apiPub.DelHelpMenuInfo,
        "data":{
          ID:data.id,
          UserID:this.currentUser.id
        }
      };
      $http.request(obj,false,function(res) {
        that.$message({
            message: '删除成功',
            type: 'success'
        });
        that.getlist(that.menuID)
      })
    },
    onDetail(e){
       this.$router.push({path: '/helpDoc/docDetail', query: {id:e.id}});
       return;
    }
    /// -----------------------分页--begin-----------------------------
    /// -----------------------分页--end-------------------------------
  }
};
</script>
<style lang="scss" scoped>
.enterprise {
  /* padding: 20px; */
  background: #fff;
}
.org-logo {
  width: 40px;
  height: 40px;
}
.top-tab{
  background-color: #fff;
  
}
.help-doc {
    ::v-deep .sj-container .sj-content-wrapper .content-right{
        width: 74%;
    }
}
.enter-input{
    width: 200px;
}
.left-card{
    width: 20%;
    margin-left: 0px;
    // overflow: auto;
    padding: 15px;
    background: #fff;
    border-radius:4px;
    margin-right: 20px;
}
 
.left-header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 8px;
    // border-bottom: 1px solid #E5EAEE;
}
.left-header-title{
    color: #1C1D21;
    font-size: 16px;
}
.header-opt-icon{
    color: #0364FF;
    cursor: pointer;
    font-size: 18px;
    padding: 2px 8px;
}

.enter-input+.enter-input{
    margin-left: 15px;
}
.el-form-item{
    margin-bottom: 0px;
     ::v-deep .el-form-item__label{
         margin:0 ;
         padding: 0;
    }
}
.type-list-tree{
   height: 90%;
    overflow: auto;
    padding-bottom: 10px;
   ::v-deep .el-tree-node__content{
    height: 40px;
    padding-right: 8px;
   
  }
   ::v-deep .custom-tree-node{
     display: block;
     width: 100%;
     white-space: break-spaces;
     display: flex;
     justify-content: space-between;
  }
}
</style>
